// Synthesised "pop" (no asset needed). Browsers only allow sound after a user gesture,
// so primeAudio() is called on the first interaction and playPop() fails silently otherwise.
let ctx = null;

function context() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  ctx = ctx || new AC();
  return ctx;
}

export function primeAudio() {
  try {
    const c = context();
    if (c && c.state === "suspended") c.resume().catch(() => {});
  } catch { /* no audio available */ }
}

export function playPop() {
  try {
    const c = context();
    if (!c) return false;
    if (c.state === "suspended") c.resume().catch(() => {});
    if (c.state !== "running") return false;
    const t = c.currentTime;

    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(360, t);
    osc.frequency.exponentialRampToValueAtTime(920, t + 0.08);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.32, t + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.24);
    osc.connect(gain).connect(c.destination);
    osc.start(t);
    osc.stop(t + 0.26);

    const len = Math.floor(c.sampleRate * 0.03);
    const buf = c.createBuffer(1, len, c.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < len; i += 1) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3);
    const noise = c.createBufferSource();
    noise.buffer = buf;
    const filt = c.createBiquadFilter();
    filt.type = "bandpass";
    filt.frequency.value = 1800;
    const ng = c.createGain();
    ng.gain.value = 0.1;
    noise.connect(filt).connect(ng).connect(c.destination);
    noise.start(t);
    return true;
  } catch {
    return false;
  }
}
